export const summaryFollowUp_style = {
  addSummaryTitleSx: {
    color: '#808080',
    fontSize: '12px',
    pb: 0.5,
  },
  valTextSx: {
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: 600,
  },
  boxCardSx: {
    bgcolor: '#F5F5F5',
    borderRadius: '8px',
    p: 2,
  },
  rootSx: {
    mt: 2,
  },
  summaryTitlesx: {
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: 500,
  },
  dividerSx: {
    mt: 1.2,
    borderStyle: 'dashed',
    borderColor: 'divider',
  },
  inputTextSx: {
    fontSize: '16px',
    color: 'text.primary',
    fontWeight: '500',
    pl: 1,
  },
  inputValueIconSx: {
    display: 'flex',
    alignItems: 'flex-end',
    pr: '20px',
  },
  inputTextShowSx: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    bgcolor: '#F5F5F5',
    pt: 1,
    pb: 1.2,
    pl: 1,
    borderRadius: '8px',
  },
  inputBoxSx: {
    display: 'flex',
    alignItems: 'center',
    bgcolor: '#F5F5F5',
    pt: 1,
    pb: 1,
    pl: 1,
    borderRadius: '8px',
  },
  inputValueSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    bgcolor: '#F5F5F5',
    pt: 1,
    pb: 1.2,
    borderRadius: 1,
  },
  inputTextSxx: {
    fontSize: '16px',
    color: 'text.primary',
    fontWeight: '500',
    pl: 1,
  },
};
